export const SD_SCHOOLS = ["UCSD", "USD", "SDSU"];

export const SD_CLAUSE_TEXT =
  "Sufficient transportation space is guaranteed for the contracted guest count. However, bus type and capacity cannot be guaranteed.";

export const SD_TRANSPORTATION_CLAUSE_HTML = `<p class="sd-transportation-clause"><span style="font-size:14px;"><strong>Transportation Note:</strong> ${SD_CLAUSE_TEXT}</span></p>`;

// Red placeholder text present in the default template when there are no additional notes
export const NO_ADDITIONAL_TERMS_PLACEHOLDER =
  "There are no additional terms, conditions, or notes for the event(s) listed in this agreement.";

// The full placeholder paragraph as it appears in the template
const PLACEHOLDER_PARAGRAPH_REGEX =
  /<p[^>]*><span[^>]*>There are no additional terms, conditions, or notes for the event\(s\) listed in this agreement\.<\/span><\/p>/;

export const shouldAutoPopulateSDClause = (regionName, eventClients) => {
  if (regionName === "SD") return true;
  if (!eventClients?.length) return false;
  return eventClients.some((ec) =>
    ec?.collaborator?.name && SD_SCHOOLS.includes(ec.collaborator.name)
  );
};

export const contractContainsSDClause = (html) => {
  return html?.includes('class="sd-transportation-clause"') || false;
};

export const injectSDClause = (html) => {
  if (!html) return html;

  // Already injected — no-op
  if (contractContainsSDClause(html)) return html;

  // If the red placeholder is present, replace it with the clause
  if (PLACEHOLDER_PARAGRAPH_REGEX.test(html)) {
    return html.replace(PLACEHOLDER_PARAGRAPH_REGEX, SD_TRANSPORTATION_CLAUSE_HTML);
  }

  // Placeholder already removed (user added other notes) — append clause after the section heading
  const additionalTermsHeading = '<u>EVENT ITINERARY - ADDITIONAL TERMS, CONDITIONS, AND NOTES</u>';
  const headingIdx = html.indexOf(additionalTermsHeading);
  if (headingIdx !== -1) {
    // Find the end of the heading paragraph
    const afterHeading = html.indexOf('</p>', headingIdx);
    if (afterHeading !== -1) {
      return (
        html.slice(0, afterHeading + 4) +
        '<p>&nbsp;</p>' +
        SD_TRANSPORTATION_CLAUSE_HTML +
        html.slice(afterHeading + 4)
      );
    }
  }

  // Fallback: inject before the payment widget (data-id="4")
  const paymentWidget = '<section class="product" data-id="4">';
  const paymentIdx = html.indexOf(paymentWidget);
  if (paymentIdx !== -1) {
    return html.slice(0, paymentIdx) + SD_TRANSPORTATION_CLAUSE_HTML + html.slice(paymentIdx);
  }

  return html + SD_TRANSPORTATION_CLAUSE_HTML;
};

export const removeSDClauseIfUnmodified = (html) => {
  if (!html || !contractContainsSDClause(html)) return html;

  // Only remove if the clause text is still the original (unedited)
  if (!html.includes(SD_CLAUSE_TEXT)) return html;

  // Remove the clause paragraph (and the spacer we inserted before it)
  const removed = html.replace('<p>&nbsp;</p>' + SD_TRANSPORTATION_CLAUSE_HTML, "")
    .replace(SD_TRANSPORTATION_CLAUSE_HTML, "");

  // If the additional notes section is now empty (no other content between heading and page-break),
  // restore the red placeholder
  const additionalTermsHeading = '<u>EVENT ITINERARY - ADDITIONAL TERMS, CONDITIONS, AND NOTES</u>';
  if (removed.includes(additionalTermsHeading)) {
    const headingIdx = removed.indexOf(additionalTermsHeading);
    const afterHeadingParagraph = removed.indexOf('</p>', headingIdx);
    const pageBreakAfter = removed.indexOf('<div class="page-break"', headingIdx);
    if (afterHeadingParagraph !== -1 && pageBreakAfter !== -1) {
      const sectionContent = removed.slice(afterHeadingParagraph + 4, pageBreakAfter);
      const hasRealContent = sectionContent.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim().length > 0;
      if (!hasRealContent) {
        const afterHeading = removed.indexOf('</p>', headingIdx);
        if (afterHeading !== -1) {
          return (
            removed.slice(0, afterHeading + 4) +
            `<p>&nbsp;</p><p><span style="color:hsl(0,75%,60%);font-size:14px;">${NO_ADDITIONAL_TERMS_PLACEHOLDER}</span></p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>` +
            removed.slice(afterHeading + 4)
          );
        }
      }
    }
  }

  return removed;
};
